module.exports = __webpack_public_path__ + "img/914-0c2965.png";